import { Button } from 'blaze-ui/Button'
import { FileEdit2 } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { EditCaptionModal } from 'components/EditCaptionModal/EditCaptionModal'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { useUpdateScheduledPost } from 'hooks/queries/scheduledPosts/useUpdateScheduledPost'
import { useQueryClient } from 'react-query'
import { updateCalendarItemInCache } from 'hooks/queries/calendar/utils'
import { maxCharacters } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { ButtonSize, ButtonVariant } from 'blaze-ui/Button/Types'
import { Icon } from 'blaze-ui/icons/Types'
import { StyleProps } from 'blaze-ui/StyleProps'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const EditCaptionButton = ({
  scheduledPost,
  almanacFileKey,
  variant = 'tertiary',
  size = 'md',
  frontIcon = FileEdit2,
  justifyContent = 'flex-start',
  fullWidth = true,
  vertical = true,
  shouldHideCaptionField = false,
  label = 'Caption',
}: {
  scheduledPost: ScheduledPostShow
  almanacFileKey: string
  variant?: ButtonVariant
  size?: ButtonSize
  frontIcon?: Icon
  justifyContent?: StyleProps['justifyContent']
  fullWidth?: boolean
  vertical?: boolean
  shouldHideCaptionField?: boolean
  label?: string
}) => {
  const workspaceId = useCurrentWorkspaceId()
  const { openModal } = useModals()
  const queryClient = useQueryClient()

  const { mutate } = useUpdateScheduledPost({
    onSuccess: (updatedScheduledPost) => {
      updateCalendarItemInCache(
        queryClient,
        almanacFileKey,
        (item) => ({
          ...item,
          scheduled_post: updatedScheduledPost,
          content: updatedScheduledPost.content,
        }),
        workspaceId,
      )
    },
  })

  const handleUpdateCaption = (caption: string) => {
    mutate({ id: scheduledPost.id, params: { content: caption } })
  }

  return (
    <Button
      variant={variant}
      size={size}
      frontIcon={frontIcon}
      justifyContent={justifyContent}
      fullWidth={fullWidth}
      vertical={vertical}
      isDisabled={shouldHideCaptionField}
      onPress={() =>
        openModal(
          EditCaptionModal,
          {
            scheduledPostId: scheduledPost.id,
            caption: scheduledPost.content || '',
            maxCharacters: scheduledPost.external_integration?.provider
              ? maxCharacters[scheduledPost.external_integration?.provider]
              : undefined,
            scheduledPostTargets: scheduledPost.scheduled_post_targets,
            onSave: (caption) => {
              handleUpdateCaption(caption)
            },
          },
          { newStack: true },
        )
      }
    >
      {label}
    </Button>
  )
}
